import header from "./working-on-laptop.jpg";
import section1 from "./working-on-pc.webp";
import section2 from "./creating-floor-plan-for-you.webp";
import section3 from "./creating-floor-plan-together.webp";
import section4de from "./create-floor-plan-de.jpg";
import section4en from "./create-floor-plan-en.jpg";

export { header, section1, section2, section3, section4de,section4en };
